export const googleMapKey = 'AIzaSyBfkSuyy45Oorhy9Cnb3V9_e-8g0QPUMoY'

// export const serverApis = ["http://localhost:3001"]
export const serverApis = ["https://backend.segundaaguada.es/"]
// export const serverApis = ['/']
